import React, { Component } from 'react';
import {FormControl, FormGroup, Button} from 'react-bootstrap';
import Header from './Header.js';
import './TaskDetail.css';
import fire from './fire';
import _ from 'lodash';

import { Link } from 'react-router-dom';
import locImg from './resources/loc.svg';
import soco from './resources/soco.png';
import wirecardLogo from './resources/Wirecard_Logo.png';
import bmwLogo from './resources/bmwlogo.jpg';

class TaskDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      task: {},
      submited: false,
    };
  }

  componentDidMount() {
    const {
      projectId,
      solutionId,
      taskId
    } = this.props.match.params;

    var taskRef = fire.database().ref('projects/' + projectId);
    taskRef.on('value', (snapshot) => {
      const project = snapshot.val()
      const task = project.solutions[solutionId].tasks[taskId];

      this.setState({task: _.assign({}, task, {projectName: project.name, projectId: snapshot.key, projectDescription: project.description})});
    });
  }

  render() {
    const {
      name,
      description,
      location,
      projectId,
      projectName,
      projectDescription
    } = this.state.task;

    return (
      <div className="task-detail">
        <Header/>
        <div className="task--name">
          {name} 
          <div className="coin--image"> 
            <img src={soco} height="20px"/>
            <div className="coin--text">50 sc</div>
          </div>
        </div>

        <div className="task--description">Task Description</div>
          <p>{description}</p>

        <Link to={`/projects/${projectId}`}>{projectName}</Link>
        <div className="locTag">
        <img src={locImg} ></img>
        <div className="locText">{location}</div>
        <div className="projectTitle">{projectName}</div>
        </div>
      
      <div className="task--signup">Sign up to volunteer for this event
      </div>
      
        {
          this.state.submited && (
            <div className="successfulSubmission">Succesfully submitted</div>
          )
        }
        {
          !this.state.submited && (
            <div>
              <div className="task--textbox">
              <FormGroup controlId="formControlsTextarea">
              <FormControl rows="3" componentClass="textarea" placeholder="(optional) message the event host" />
            </FormGroup>
              </div>
              <div className="signup--button">
                <Button onClick={()=> this.setState({submited: true})}>sign up</Button>
              </div>
            </div>
          )
        }
       <div className="problem--header">Project Description</div>
        <div className="problem--description">{projectDescription}</div>
        <div className="problem--partnership">in partnership with     
          <div className="partnerLogos"><img src={wirecardLogo} height="30px"/><img src={bmwLogo} height="100px"/>
          </div>
        </div>
        </div>
      
    );
  }
}

export default TaskDetail;



// WEBPACK FOOTER //
// ./src/TaskDetail.js